<div class="main-db gap-top">
    <div class="container-fluid mt-2">

        <div class="row">
            <div class="col-12 col-sm-6">
            <h1>{{title}}</h1>
            </div>
        </div>


        <div class="main-content">
            <div>




                <div *ngIf="userRole == 'ROLE_ADMIN_ORGANIZATION'">
                    <div class="card">
                        <div class="card-header font-weight-bold row">
                            <h5 class="col-6">LIVE</h5>

                            <div class="col-6">
                                <a type="button" class="mr-3 mt-2 float-right" (click)="setExportData(liveSectionBarChartData, liveSectionCanvas, 'LIVE')" data-toggle="modal" data-target="#selectExportType">
                                  <i class="fas fa-download mr-1" aria-hidden="true" matTooltip="Export Report"></i>
                                </a>
                            </div>
                        </div>

                        <div class="card-body" #liveSectionCanvas>

                            <div class="row">
                                <div class="col-6 row mt-4">
                                    <div class="col-6">
                                        <div class="card cardBorderRadius">
                                            <h5 class="card-header h5">Shifts</h5>
                                            <div class="card-body row">
                                                <div class="col-6">
                                                    <i class="fas fa-exchange-alt fa-4x"></i>
                                                </div>
                                                <div class="col-6">
                                                    <h3 class="centreText font-weight-bold">{{liveSectionBarChartData.totalShifts}}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-6">
                                        <div class="card cardBorderRadius">
                                            <h5 class="card-header h5">Scans</h5>
                                            <div class="card-body row">
                                                <div class="col-6">
                                                    <img src="assets/images/scan_icon.png" class="filter" alt="" style="height: 60px; width: 60px;">
                                                </div>
                                                <div class="col-6">
                                                    <h3 class="centreText font-weight-bold">{{liveSectionBarChartData.totalScans}}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-4">
                                        <div class="card cardBorderRadius">
                                            <h5 class="card-header h5">Authorized</h5>
                                            <div class="card-body row">
                                                <div class="col-4">
                                                    <i class="far fa-check-circle fa-3x"></i>
                                                </div>
                                                <div class="col-8">
                                                    <h3 class="centreText font-weight-bold">{{liveSectionBarChartData.totalAuthorized}}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-4">
                                        <div class="card cardBorderRadius">
                                            <h5 class="card-header h5">Unpaid</h5>
                                            <div class="card-body row">
                                                <div class="col-4">
                                                    <i class="far fa-times-circle fa-3x"></i>
                                                </div>
                                                <div class="col-8">
                                                    <h3 class="centreText font-weight-bold">{{liveSectionBarChartData.totalUnpaid}}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-4">
                                        <div class="card cardBorderRadius">
                                            <h5 class="card-header h5">Expired</h5>
                                            <div class="card-body row">
                                                <div class="col-4">
                                                    <i class="far fa-clock fa-3x"></i>
                                                </div>
                                                <div class="col-8">
                                                    <h3 class="centreText font-weight-bold">{{liveSectionBarChartData.totalExpired}}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-6">
                                    <div class="card">
                                        <h5 class="card-header h5">Bar Chart</h5>
                                        <div class="card-body row">
                                            <div style="display: block" class="mx-auto">
                                                <canvas id="liveSectionBarChart">
                                                    {{liveSectionBarChart}}
                                                </canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




















                <div *ngIf="userRole == 'ROLE_ADMIN_ORGANIZATION'">
                    <div class="card" #vehicleLocationMapCanvas>
                        <div class="card-header font-weight-bold row">
                            <h5 class="col-6">Vehicle Location Map</h5>

                            <div class="col-6">
                                <a type="button" class="mr-3 mt-2 float-right" (click)="setExportData(peoLastLocationData, liveSectionCanvas,'Vehicle Location Map')" data-toggle="modal" data-target="#selectExportType">
                                  <i class="fas fa-download mr-1" aria-hidden="true" matTooltip="Export Report"></i>
                                </a>
                            </div>
                        </div>

                        <div class="card-body">

                            <div class="row">
                                <div class="col-3 mt-4 cardBodySidebar">
                                    <mat-tab-group class="geofenceTabs" (selectedTabChange)="onPeoMapTabChanged($event);" (click)="onPeoMapTabClicked()">
                                        <mat-tab label="All"></mat-tab>
                                        <mat-tab *ngFor="let peoData of peoLastLocationData | slice:0:3; let i = index" label="{{ carList[i] }}"></mat-tab>
                                      </mat-tab-group>
                                </div>

                                <div class="col-9">
                                    <agm-map class="col-10" [zoom]="10" [latitude]="selectedPeoLocation?.latitude" [longitude]="selectedPeoLocation?.longitude">

                                        <agm-marker *ngIf="this.selectedPeoIndex != 0" [iconUrl]='markerIcon' [latitude]="selectedPeoLocation.latitude" [longitude]="selectedPeoLocation.longitude">
                                            <agm-info-window [isOpen]="infoOpen" [latitude]="selectedPeoLocation.latitude" [longitude]="selectedPeoLocation.longitude">
                                                <div class="card">
                                                  <div class="card-body">
                                                    <h6 class="text-center">{{selectedPeoLocation.peoName}}</h6>
                                                    <h6 class="text-center">{{selectedPeoLocation.createdDate | date : "HH:mm:ss y-MM-dd"}}</h6>
                                                    <h6 class="text-center">{{selectedPeoLocation.geofenceName}}</h6>
                                                  </div>
                                                </div>
                                              </agm-info-window>
                                        </agm-marker>

                                        <span *ngIf="this.selectedPeoIndex == 0">
                                            <agm-marker *ngFor="let marker of peoLastLocationData; let i = index "
                                                        [iconUrl]='markerIcon' [latitude]="marker.latitude" [longitude]="marker.longitude">
                                                <agm-info-window [isOpen]="infoOpen" [latitude]="marker.latitude" [longitude]="marker.longitude">
                                                    <div class="card">
                                                      <div class="card-body">
                                                        <h6 class="text-center">{{marker.peoName}}</h6>
                                                        <h6 class="text-center">{{marker.createdDate | date : "HH:mm:ss y-MM-dd"}}</h6>
                                                        <h6 class="text-center">{{marker.geofenceName}}</h6>
                                                      </div>
                                                    </div>
                                                  </agm-info-window>
                                            </agm-marker>
                                        </span>
                                      </agm-map>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>






















                <div *ngIf="userRole == 'ROLE_ADMIN_ORGANIZATION'" class="mt-5">

                    <div class="row mb-4">
                        <div class="col-6">
                            <div class="col-4 float-left form-group p-1 mt-2">
                                <select class="form-control form-control-sm input-custom" (change)="onChangeGeofenceId($event.target.value)">
                                  <option value="">Select Zone</option>
                                  <option *ngFor="let geofenceData of allGeofenceData" [value]="geofenceData.geofenceId">
                                    {{geofenceData.geofenceName}}
                                  </option>
                                </select>
                            </div>
                            <div class="col-4 float-left form-group p-1 mt-2">
                                <select class="form-control form-control-sm input-custom" (change)="onChangePeoId($event.target.value)">
                                  <option value="">Select PEO</option>
                                  <option *ngFor="let peoUser of peoUsersData" [value]="peoUser.userId">
                                    {{peoUser.firstName + ' ' + peoUser.lastName}}
                                  </option>
                                </select>
                            </div>
                            <div class="col-2 float-left form-group p-1 mt-2">
                                <input class="btn btn-sm btn-success w-100" type="button" (click)="getAllDataMethods()" value="Search"/>
                            </div>
                        </div>
                        <div class="col-6">
                            <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChanged($event);">
                                <mat-tab label="Day"></mat-tab>
                                <mat-tab label="Week"></mat-tab>
                                <mat-tab label="Month"></mat-tab>
                                <mat-tab label="Custom"></mat-tab>
                            </mat-tab-group>
                            <div *ngIf="selectedTabIndex == 3" class="p-1 col-4">
                                <input readonly type="text" matInput placeholder="Select Date Range"
                                  class="form-control form-control-sm  input-custom pl-2 mt-0"
                                  ngxDaterangepickerMd
                                  [locale]="{format: 'YYYY-MM-DD'}"
                                  [(ngModel)]="selectedDateCustom"
                                  startKey="start"
                                  endKey="end"
                                  [showCustomRangeLabel]="true"
                                  [alwaysShowCalendars]="true"
                                  [linkedCalendars]="true"
                                  name="daterange"
                                  (change)="onChangeDateRange($event)"/>
                              </div>
                        </div>
                    </div>



















                    <div class="card">
                        <h5 class="card-header font-weight-bold">Violations</h5>
                        <div class="card-body">

                            <div class="row font-weight-bold">
                                <div class="col-6" #violationTrendsCanvas>
                                    <div class="row">
                                        <h6 class="text-right col-7">Violation Trends</h6>
                                        <div class="col-5">
                                            <a type="button" class="mr-3 mt-2 float-right" (click)="setExportData(violationSectionLineChartData, liveSectionCanvas, 'Violation Trends')" data-toggle="modal" data-target="#selectExportType">
                                              <i class="fas fa-download mr-1" aria-hidden="true" matTooltip="Export Report"></i>
                                            </a>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="">
                                            <div style="display: block">
                                            <canvas  id="violationSectionLineChart" >{{ chart }}</canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-6" #violationInsightsCanvas>
                                    <div class="row">
                                        <h6 class="text-right col-7">Violation Insights</h6>
                                        <div class="col-5">
                                            <a type="button" class="mr-3 mt-2 float-right" (click)="setExportData(violationSectionBarChartData, liveSectionCanvas, 'Violation Insights')" data-toggle="modal" data-target="#selectExportType">
                                              <i class="fas fa-download mr-1" aria-hidden="true" matTooltip="Export Report"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div style="margin-left: 50px; margin-top: 50px;">

                                        <div class="row">
                                            <div class="col-6 mt-4">{{'Unauthorized : ' + (violationSectionBarChartData.totalUnauthorized || 0)}}</div>
                                            <div class="col-4 mt-4 text-right">{{unauthProgressBar}}</div>
                                        </div>
                                        <div class="progress">
                                            <div class="progress-bar bg-warning" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                [ngStyle]='{ width : unauthProgressBar }'>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 mt-4">{{'Unpaid : ' + (violationSectionBarChartData.totalUnpaid || 0)}}</div>
                                            <div class="col-4 mt-4 text-right">{{unpaidProgressBar}}</div>
                                        </div>
                                        <div class="progress">
                                            <div class="progress-bar bg-warning" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                [ngStyle]='{ width : unpaidProgressBar }'>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6 mt-4">{{'Expired : ' + (violationSectionBarChartData.totalExpired || 0)}}</div>
                                            <div class="col-4 mt-4 text-right">{{expiredProgressBar}}</div>
                                        </div>
                                        <div class="progress">
                                            <div class="progress-bar bg-warning" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                [ngStyle]='{ width : expiredProgressBar }'>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div class="col-12 mt-5">

                                </div>

                                <div class="col-6" #hotspotZoneScansCanvas>
                                    <div class="row">
                                        <h6 class="text-right col-7">Hotspot Zones Scans</h6>
                                        <div class="col-5">
                                            <a type="button" class="mr-3 mt-2 float-right" (click)="setExportData(violationSectionBarChartData.data, liveSectionCanvas, 'Hotspot Zones Scans')" data-toggle="modal" data-target="#selectExportType">
                                              <i class="fas fa-download mr-1" aria-hidden="true" matTooltip="Export Report"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div style="display: block" class="ml-5">
                                        <canvas id="violationSectionBarChart">
                                            {{violationSectionBarChart}}
                                        </canvas>
                                    </div>
                                </div>

                                <div class="col-6" #hotspotZoneViolationsCanvas>
                                    <div class="row">
                                        <h6 class="text-right col-7">Hotspot Zones Violations</h6>
                                        <div class="col-5">
                                            <a type="button" class="mr-3 mt-2 float-right" (click)="setExportData(violationSectionBarChartData.data, liveSectionCanvas, 'Hotspot Zones Violations')" data-toggle="modal" data-target="#selectExportType">
                                              <i class="fas fa-download mr-1" aria-hidden="true" matTooltip="Export Report"></i>
                                            </a>
                                        </div>
                                    </div>

                                    <div class="row mt-5">
                                        <div class="col-4 cirlceProgressZone" style="display: block" *ngFor="let progressPercentage of zoneProgressPercentage | slice:0:3; let i=index">
                                            <circle-progress [options]="defaultCircleProgressOptions" [percent]="progressPercentage"></circle-progress>
                                            <span class="circleProgressPopup">{{violationSectionBarChartData.data[i]? violationSectionBarChartData.data[i].violationCount : 0}}</span>
                                        </div>
                                        <div class="col-4 text-center" *ngFor="let violationData of violationSectionBarChartData.data | slice:0:3;">
                                            {{violationData.geofenceName}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>






















                <div *ngIf="userRole == 'ROLE_ADMIN_ORGANIZATION'">
                    <div class="card">
                        <h5 class="card-header font-weight-bold">PEO Shifts</h5>
                        <div class="card-body">

                            <div class="row font-weight-bold">
                                <div class="col-6" #scannedViolationByPeoCanvas>
                                    <div class="row">
                                        <h6 class="text-right col-7">Scanned Violations By PEO</h6>
                                        <div class="col-5">
                                            <a type="button" class="mr-3 mt-2 float-right" (click)="setExportData(peoSectionProgressBar, liveSectionCanvas, 'Scanned Violations By PEO')" data-toggle="modal" data-target="#selectExportType">
                                              <i class="fas fa-download mr-1" aria-hidden="true" matTooltip="Export Report"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div style="margin-left: 50px; margin-top: 50px;">

                                        <div *ngFor="let peoData of peoSectionProgressBar | slice:0:3; let i = index">
                                            <div class="row">
                                                <div class="col-6 mt-4">{{peoSectionBarChartData[i]? peoSectionBarChartData[i].peoName: ""}}</div>
                                                <div class="col-4 mt-4 text-right">{{peoData}}</div>
                                            </div>
                                            <div class="progress">
                                                <div class="progress-bar" style="background-color: goldenrod;" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                                    [ngStyle]='{ width : peoData }'>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div class="col-6" #scannedViolationByZoneCanvas>
                                    <div class="row">
                                        <h6 class="text-right col-7">Scanned Violations By Zone</h6>
                                        <div class="col-5">
                                            <a type="button" class="mr-3 mt-2 float-right" (click)="setExportData(violationSectionBarChartData.data, liveSectionCanvas, 'Scanned Violations By Zone')" data-toggle="modal" data-target="#selectExportType">
                                              <i class="fas fa-download mr-1" aria-hidden="true" matTooltip="Export Report"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div style="display: block" class="ml-5">
                                        <canvas id="peoSectionBarChart">
                                            {{peoSectionBarChart}}
                                        </canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>






















                <div *ngIf="userRole == 'ROLE_ADMIN_ORGANIZATION'">
                    <div class="card">
                        <div class="card-header font-weight-bold row">
                            <h5 class="col-6">Revenue</h5>

                            <!-- <div class="col-6">
                                <div class="row w-50 float-right">
                                    <input class="col-7 mr-2 form-control form-control-sm input-custom" type="number" placeholder="Amount" [(ngModel)]="revenuePrice"/>
                                    <input class="btn btn-sm btn-success col-4" type="button" value="Calculate" (click)="calculateRevenue()"/>
                                </div>
                            </div>     -->
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-3">
                                    <h6 class="text-center mb-5" style="height: 15%;">Financial Insights</h6>
                                    <div class="text-center mt-4 h-25">
                                        <h1 class="h1 font-weight-bold">{{'$' + violationTotalRevenue}}</h1>
                                    </div>
                                    <!-- <div class="row">
                                        <h6 class="col-5 text-center text-success font-weight-bold">↑ 7.00%</h6>
                                        <h6 class="col-7 font-weight-bold">Since Last Week</h6>
                                    </div> -->
                                </div>

                                <div class="col-5">
                                    <div class="row">
                                        <h6 class="text-right col-7">Revenue By Zone</h6>
                                        <div class="col-5">
                                            <a type="button" class="mr-3 mt-2 float-right" (click)="setExportData(revenueViolationData, liveSectionCanvas, 'Revenue By Zone')" data-toggle="modal" data-target="#selectExportType">
                                              <i class="fas fa-download mr-1" aria-hidden="true" matTooltip="Export Report"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div style="display: block">
                                        <canvas id="revenueSectionZoneBarChart">
                                            {{revenueSectionZoneBarChart}}
                                        </canvas>
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="row">
                                        <h6 class="text-right col-7">Revenue Analytics</h6>
                                        <div class="col-5">
                                            <a type="button" class="mr-3 mt-2 float-right" (click)="setExportData(revenueMonthlyViolationData, liveSectionCanvas, 'Revenue Analytics')" data-toggle="modal" data-target="#selectExportType">
                                              <i class="fas fa-download mr-1" aria-hidden="true" matTooltip="Export Report"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div style="display: block">
                                        <canvas id="revenueSectionAnalyticsBarChart">
                                            {{revenueSectionAnalyticsBarChart}}
                                        </canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
























                <div *ngIf="userRole == 'ROLE_ADMIN_ORGANIZATION'">
                    <div class="card">
                        <div class="card-header font-weight-bold row">
                            <h5 class="col-6">Traffic Flow Monitor</h5>

                            <!-- <div class="col-6">
                                <a type="button" class="mr-3 mt-2 float-right" (click)="setExportData(selectedGeofenceShiftDetails, 'Traffic Flow Monitor')" data-toggle="modal" data-target="#selectExportType">
                                  <i class="fas fa-download mr-1" aria-hidden="true" matTooltip="Export Report"></i>
                                </a>
                            </div>     -->
                        </div>
                        <div class="card-body">

                            <div class="row">
                                <div class="col-3 mt-4 cardBodySidebar">
                                    <!-- <mat-tab-group class="trafficFlowMapTabs" [selectedIndex]="selectedTabIndexTrafficMap" (selectedTabChange)="onTrafficFlowMapTabChanged($event);">
                                        <mat-tab  [disabled]="true" label="Zones&emsp;&emsp;|&emsp;&emsp;Scan&emsp;&emsp;|&emsp;&emsp;Violation"></mat-tab>
                                        <mat-tab *ngFor="let mapTab of trafficFlowMapTabList"
                                                 label="{{mapTab.geofenceName}}&emsp;&emsp;{{mapTab.totalScan}}&emsp;&emsp;{{mapTab.violationCount}}">
                                        </mat-tab>
                                      </mat-tab-group> -->

                                      <table class="table">
                                        <thead>
                                          <tr>
                                            <th>Zones</th>
                                            <th>Scans</th>
                                            <th>Violations</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr *ngFor="let row of violationSectionBarChartData.data" class="text-bold"
                                                (click)="onRowClicked(row, row.geofenceId)" [class.selected-row]="heatmapSelectedRowIndex === row.geofenceId">
                                            <td>{{ row.geofenceName }}</td>
                                            <td>{{ row.totalScan }}</td>
                                            <td>{{ row.violationCount }}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                </div>

                                <div class="col-9">
                                    <agm-map class="col-10"
                                            [zoom]="18"
                                            [latitude]="defaultLocation.latitude"
                                            [longitude]="defaultLocation.longitude"
                                            (mapReady)="onMapLoad($event)">
                                    </agm-map>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>





                <div class="modal fade" id="selectExportType" tabindex="-1" role="dialog" aria-labelledby="selectExportTypeLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title orange-text" id="selectExportTypeLabel">Select Export Form</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div class="modal-body text-center">
                                <button class="btn btn-success mr-2" (click)="exportExcelAll()" data-dismiss="modal">Export CSV</button>
                                <button class="btn btn-success mr-2" (click)="exportPdfAll()" data-dismiss="modal">Export PDF</button>
                                <!-- <button class="btn btn-success" (click)="exportPNG()" data-dismiss="modal">Export PNG</button> -->
                            </div>
                        </div>
                    </div>
                </div>


                <div id="download">
                    <img #canvas>
                    <a #downloadLink></a>
                </div>

        </div>
    </div>
</div>
